import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUITranslation } from '../../i18n/index.js';
export function NotFoundView({}) {
    const { t } = useUITranslation();
    return (_jsxs("div", { className: "text-center pt-32", children: [_jsx("h1", { className: "text-3xl font-bold text-red-500", children: "404" }), _jsx("p", { className: "text-2xl", children: t('layout.pageNotFound') })] }));
}
//# sourceMappingURL=NotFoundView.js.map